var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "list-item",
    {
      attrs: {
        booking: _vm.booking,
        link: { name: "requests.show", params: { id: _vm.booking.id } },
      },
      scopedSlots: _vm._u([
        {
          key: "status",
          fn: function () {
            return [
              _vm.booking.urgent
                ? _c("div", { staticClass: "spacer-b-2" }, [
                    _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("title", [
        _c("span", [_vm._v(_vm._s(_vm.bookingName))]),
        _vm._v(" "),
        _vm.$userIsAdmin
          ? _c("span", [_vm._v(" - " + _vm._s(_vm.bookingDateCreated))])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("price", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm._f("currency")(
                _vm.booking.budget_per_star,
                _vm.booking.currency
              )
            ) +
            "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }